import CryptoJS from "crypto-js";
export function ae(Str: string, mode = "gtdcy") {
  // work3
  let aeskey = "1K3IsS2CFTefOJli";
  if (mode == "gy") {
    aeskey = "hnN1L44hvi6Ox1de";
  } else if (mode == "cloudquery") {
    aeskey = "vb2iMBzVxJcbGTV5";
  } else if (mode == "bus") {
    aeskey = "qyrnq21oUPFkZhje";
  }
  const key = CryptoJS.enc.Utf8.parse(aeskey);
  const srcs = CryptoJS.enc.Utf8.parse(Str);
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    // 切记，需要和后端算法模式一致
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString();
}

export function ad(Str: string, mode = "gtdcy") {
  // work3
  let aeskey = "1K3IsS2CFTefOJli";
  if (mode == "gy") {
    aeskey = "hnN1L44hvi6Ox1de";
  } else if (mode == "cloudquery") {
    aeskey = "vb2iMBzVxJcbGTV5";
  } else if (mode == "bus") {
    aeskey = "qyrnq21oUPFkZhje";
  }
  const key = CryptoJS.enc.Utf8.parse(aeskey);
  const decrypt = CryptoJS.AES.decrypt(Str, key, {
    // 切记，需要和后端算法模式一致
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}

export function getAesKey(mode = "gtdcy") {
  return "aG5OMUw0NGh2aTZPeDFkZQ==";
}
